import type { DashboardSharingType } from '@risksmart-app/domain/src/types/consts/dashboard-sharing-type';
import type { InsertDashboardMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import {
  InsertDashboardDocument,
  namedOperations,
} from '@risksmart-app/web-graphql-client/generated/graphql';

import type { FrontendRouterInputs } from '@/hooks/mutations/routerInputs';
import { createMutationHook } from '@/utils/hook-factories';

type InsertDashboardTRPCInput = FrontendRouterInputs['dashboard']['insert'];

export interface InsertDashboardInput {
  Name: string;
  Description?: string | null;
  Sharing: DashboardSharingType;
  Content?: InsertDashboardTRPCInput['Content'];
  ContributorUserIds: string[];
  ContributorGroupIds: string[];
}

export const useInsertDashboard = createMutationHook({
  name: 'insertDashboard',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.dashboard.insert.mutationOptions({ onSuccess }),
  mapInput: (input: InsertDashboardInput) => input,
  invalidate: (trpc) => [
    trpc.frontend.dashboard.dashboards.queryKey(),
    trpc.frontend.dashboard.dashboardById.queryKey(),
  ],
  mapResponse: (result: { Id: string }): InsertDashboardMutation => ({
    insertChildDashboard: { __typename: 'IdOutput', Id: result.Id },
  }),
  graphqlDocument: InsertDashboardDocument,
  graphqlVariables: (input: InsertDashboardInput) => ({
    Name: input.Name,
    Description: input.Description,
    Sharing: input.Sharing,
    Content: input.Content,
    ContributorUserIds: input.ContributorUserIds,
    ContributorGroupIds: input.ContributorGroupIds,
  }),
  refetchQueries: [namedOperations.Query.getDashboards],
});
